module.exports = __webpack_public_path__ + "static/media/protocol.7c70ec4c.htm";